import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { SavedSearchService } from '../../../services/saved-search.service';
import { SaveQueryDialogData, CreateSavedSearchRequest } from '../../../interfaces/saved-search.interface';

@Component({
  selector: 'app-save-query-dialog',
  templateUrl: './save-query-dialog.component.html',
  styleUrls: ['./save-query-dialog.component.less']
})
export class SaveQueryDialogComponent implements OnInit {
  saveQueryForm: UntypedFormGroup;
  loading = false;
  dialogData: SaveQueryDialogData;

  constructor(
    private fb: UntypedFormBuilder,
    private modalRef: NzModalRef,
    private savedSearchService: SavedSearchService,
    private message: NzMessageService
  ) {
    this.dialogData = this.modalRef.getConfig().nzData || {};
    this.saveQueryForm = this.fb.group({
      queryName: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(100)]],
      isDefault: [false]
    });
  }

  ngOnInit(): void {}

  get f() {
    return this.saveQueryForm.controls;
  }

  onSave(): void {
    if (this.saveQueryForm.invalid) {
      Object.values(this.saveQueryForm.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
      return;
    }

    this.loading = true;

    const request: CreateSavedSearchRequest = {
      queryName: this.saveQueryForm.value.queryName.trim(),
      searchCriteria: this.savedSearchService.stringifySearchCriteria(this.dialogData.searchCriteria),
      configuredColumns: this.dialogData.configuredColumns || [],
      isDefault: this.saveQueryForm.value.isDefault
    };

    const dashboardId = this.dialogData.dashboardId || this.savedSearchService.getDashboardIdFromRoute();

    this.savedSearchService.createSavedSearch(request, dashboardId).subscribe({
      next: (response) => {
        this.loading = false;
        this.message.success('Query saved successfully');
        this.modalRef.close(true);
      },
      error: (error) => {
        this.loading = false;
        const errorData = error.error?.data || error.error?.message || '';
        const errorMessage = error.error?.message || '';
        
        if (errorData.includes('already exists') || errorMessage.includes('already exists')) {
          this.message.error(error.error?.message);
        } else {
          this.message.error(errorMessage || 'Failed to save query. Please try again.');
        }
      }
    });
  }

  onCancel(): void {
    this.modalRef.close(false);
  }
}
